import apiInstance from './Axios';
import { endpoints } from './Constants';
const { GET_ALL_ZONES } = endpoints;

export const getAllZones = () => apiInstance.get(GET_ALL_ZONES);
